// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f95bc847","453":"9eadaea2"}[chunkId] + ".chunk.js";
};